import generateLaptopSubtitle from '@components/board/RecordArticleLaptop/generateLaptopSubtitle'
import getLaptopProsAndCons from '../ProsCons/getLaptopProsAndCons'
import { pluck } from 'rambda'

export default (
  laptopsSelected,
  laptopEvaluations,
  laptopOld,
  laptopNew,
  articleTopic,
) => {
  const laptopIdsSelected = pluck('laptopId', laptopsSelected)

  const articleLaptopNew = {
    laptopId: laptopNew.id,
    price: laptopNew.price,
    alternativeToLaptopId: laptopOld.alternativeToLaptopId,
    subtitle: generateLaptopSubtitle(laptopNew, articleTopic),
    ...getLaptopProsAndCons(
      { laptopId: laptopNew.id },
      laptopEvaluations,
      laptopIdsSelected,
      articleTopic,
    ),
  }

  return [
    ...laptopsSelected
      .filter(({ laptopId }) => laptopId !== laptopOld.laptopId)
      .map(laptop => {
        if (laptop.alternativeToLaptopId === laptopOld.laptopId) {
          return {
            ...laptop,
            alternativeToLaptopId: laptopNew.id,
          }
        }

        return laptop
      }),
    articleLaptopNew,
  ]
}
